(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-cursor-glitter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('bc-cursor-glitter')) return;
    class BCCursorGlitter extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.finePointer = matchMedia('(hover: hover) and (pointer: fine)');
        this.colors = ['#fa67ac', '#47ddd6', '#be92fa', '#ffe25c'];
        this.lastPoint = null;
        this.lastTime = -Infinity;
        this.colorIndex = 0;
        const refresh = () => {
          this.enabled = this.finePointer.matches && !this.reducedMotion.matches && !document.hidden && !document.documentElement.hasAttribute('data-bca-motion');
          if (!this.enabled) this.clear();
        };
        document.addEventListener('pointermove', event => this.move(event), { passive: true, signal });
        document.addEventListener('pointerout', event => { if (!event.relatedTarget) this.clear(); }, { passive: true, signal });
        document.addEventListener('visibilitychange', refresh, { signal });
        window.addEventListener('blur', () => this.clear(), { signal });
        window.addEventListener('pagehide', () => this.clear(), { signal });
        this.reducedMotion.addEventListener('change', refresh, { signal });
        this.finePointer.addEventListener('change', refresh, { signal });
        this.addEventListener('animationend', event => {
          if (event.target.parentElement === this) event.target.remove();
        }, { signal });
        this.observer = new MutationObserver(refresh);
        this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bca-motion'] });
        refresh();
      }
      move(event) {
        if (!this.enabled || event.pointerType !== 'mouse') return;
        if (event.target.closest?.('input, textarea, select, [contenteditable="true"], dialog, [role="dialog"]')) { this.lastPoint = null; return; }
        const now = performance.now();
        if (now - this.lastTime < 40) return;
        const x = event.clientX;
        const y = event.clientY;
        if (this.lastPoint && Math.hypot(x - this.lastPoint.x, y - this.lastPoint.y) < 12) return;
        this.lastPoint = { x, y };
        this.lastTime = now;
        const spark = document.createElement('span');
        const dot = this.colorIndex % 3 === 0;
        const size = dot ? 6 : 12 + Math.random() * 4;
        spark.className = `bc-cursor-glitter__spark${dot ? ' bc-cursor-glitter__spark--dot' : ''}`;
        spark.style.setProperty('--bc-glitter-x', `${x - size / 2 + (Math.random() - .5) * 6}px`);
        spark.style.setProperty('--bc-glitter-y', `${y - size / 2 + (Math.random() - .5) * 6}px`);
        spark.style.setProperty('--bc-glitter-size', `${size}px`);
        spark.style.setProperty('--bc-glitter-color', this.colors[this.colorIndex++ % this.colors.length]);
        spark.style.setProperty('--bc-glitter-dx', `${(Math.random() - .5) * 16}px`);
        spark.style.setProperty('--bc-glitter-spin', `${(Math.random() - .5) * 80}deg`);
        if (this.childElementCount >= 24) this.firstElementChild.remove();
        this.append(spark);
      }
      clear() { this.replaceChildren(); this.lastPoint = null; this.lastTime = -Infinity; }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.clear();
        this.controller = null;
      }
    }
    customElements.define('bc-cursor-glitter', BCCursorGlitter);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bc-site-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('bc-site-controls')) return;
    class BCSiteControls extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.key = 'box-craze-accessibility-v1';
        this.prefs = { motion: false, large: false, links: false };
        try {
          const saved = JSON.parse(localStorage.getItem(this.key) || '{}');
          for (const key of Object.keys(this.prefs)) this.prefs[key] = saved?.[key] === true;
        } catch {}
        this.system = matchMedia('(prefers-reduced-motion: reduce)');
        this.dialog = this.querySelector('dialog');
        this.fields = this.querySelectorAll('[data-bca-pref]');
        this.querySelectorAll('[data-bca-open], [data-bca-cookies]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-bca-open]');
          if (trigger) { this.returnFocus = trigger; this.dialog.showModal(); }
          if (event.target.closest('[data-bca-close]')) this.dialog.close();
          if (event.target.closest('[data-bca-reset]')) {
            this.prefs = { motion: false, large: false, links: false };
            this.save(); this.apply();
          }
          const cookies = event.target.closest('[data-bca-cookies]');
          if (cookies) this.openCookies(cookies);
        }, { signal });
        this.dialog.addEventListener('close', () => this.returnFocus?.focus(), { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('button, input, a[href]')].filter(element => !element.disabled && element.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, { signal });
        this.addEventListener('change', event => {
          const key = event.target.dataset.bcaPref;
          if (!Object.hasOwn(this.prefs, key)) return;
          this.prefs[key] = event.target.checked;
          this.save(); this.apply();
        }, { signal });
        document.addEventListener('click', event => {
          const toggle = event.target.closest('.bc-motion, .bcp-motion');
          if (!toggle || this.syncing) return;
          this.prefs.motion = toggle.getAttribute('aria-pressed') !== 'true';
          this.save(); this.apply();
        }, { signal });
        this.system.addEventListener('change', () => this.apply(), { signal });
        document.addEventListener('shopify:section:load', () => this.apply(), { signal });
        this.observer = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.bc-motion, .bcp-motion') || node.querySelector?.('.bc-motion, .bcp-motion'))))) this.apply();
        });
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.apply();
      }
      save() { try { localStorage.setItem(this.key, JSON.stringify(this.prefs)); } catch {} }
      apply() {
        const motion = this.prefs.motion || this.system.matches;
        document.documentElement.toggleAttribute('data-bca-motion', motion);
        document.documentElement.toggleAttribute('data-bca-large', this.prefs.large);
        document.documentElement.toggleAttribute('data-bca-links', this.prefs.links);
        this.fields.forEach(field => {
          field.checked = field.dataset.bcaPref === 'motion' ? motion : this.prefs[field.dataset.bcaPref];
          field.disabled = field.dataset.bcaPref === 'motion' && this.system.matches;
        });
        this.querySelector('[data-bca-system]').hidden = !this.system.matches;
        this.syncing = true;
        document.querySelectorAll('.bc-motion, .bcp-motion').forEach(toggle => {
          const enabled = toggle.getAttribute('aria-pressed') === 'true';
          if (enabled === motion) toggle.click();
        });
        this.syncing = false;
        if (motion) document.querySelectorAll('video[autoplay]').forEach(video => video.pause());
      }
      async openCookies(button) {
        const status = this.querySelector('[data-bca-status]');
        status.hidden = true;
        button.setAttribute('aria-busy', 'true');
        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('not-ready');
          await window.privacyBanner.showPreferences();
        } catch { status.hidden = false; }
        finally { button.removeAttribute('aria-busy'); }
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.controller = null; }
    }
    customElements.define('bc-site-controls', BCSiteControls);
  })();
  } catch(e) { console.error(e); }
})();

})();
